import { BusinessUnitEntity } from '@/domains/business-unit/entities';
import { Typography } from 'antd';
import { get } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  detailBusinessUnit: BusinessUnitEntity;
}

export const SalesTargetRankingDisplay = ({ detailBusinessUnit }: Props) => {
  const { t } = useTranslation();
  const kpiTarget = get(detailBusinessUnit, 'salesTargetRanking.kpiTarget');

  return (
    <div className='w-full flex flex-wrap gap-3'>
      <div className='px-3'>
        <div className='bg-blue-100 border border-blue-300 rounded-xl p-3 shadow-sm inline-block'>
          <Typography.Text className='text-blue-700 text-sm font-medium'>
            {t('common.kpiTargetCurrentMonth')}
          </Typography.Text>
          <div className='text-base font-semibold text-blue-900'>
            {kpiTarget != null
              ? new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(
                kpiTarget,
              )
              : 'N/A'}
          </div>
        </div>
      </div>

      <div className='px-3'>
        <div className='bg-green-100 border border-green-300 rounded-xl p-3 shadow-sm inline-block'>
          <Typography.Text className='text-green-700 text-sm font-medium'>{t('common.rank')}</Typography.Text>
          <div className='text-base font-semibold text-green-900'>
            {get(detailBusinessUnit, 'salesTargetRanking.currentRank.rank') ?? 'N/A'}
          </div>
        </div>
      </div>
    </div>
  );
};
